import { toast } from "sonner";
import { ShieldX } from "lucide-react";
import StageShell from "@/components/StageShell";
import ChangeCard from "@/components/ChangeCard";
import { useRun } from "@/hooks/useRun";
import { api, errMsg } from "@/lib/api";

export default function Stage8({ job, refresh }) {
  const runHook = useRun(job.id, 8, () => refresh());
  const h = job.humanize;
  const decide = async (rw, action, text) => {
    try { await api.post(`/jobs/${job.id}/humanize/${rw.id}`, { action, text }); refresh(); }
    catch (e) { toast.error(errMsg(e)); }
  };
  return (
    <StageShell job={job} stage={8} refresh={refresh} runHook={runHook}
      runs={[{ action: "humanize", label: h ? "Re-scan & rewrite" : "Scan & rewrite", testid: "humanize-run-button" }]}>
      {!h ? <div className="card-surface text-sm text-muted-foreground">Scans for AI-tell words (editable in Settings), em dashes, repeated verbs and openings, and runs of same-length bullets. Only flagged lines are rewritten.</div> : (
        <>
          <div className="grid grid-cols-3 gap-4">
            <div className="card-surface" data-testid="ai-tell-score-before"><div className="label-xs">AI-tell score before</div><div className="text-4xl font-extrabold font-display text-amber-400">{h.before_score}</div><div className="text-xs text-muted-foreground">% of lines flagged</div></div>
            <div className="card-surface" data-testid="ai-tell-score-after"><div className="label-xs">After valid rewrites</div><div className="text-4xl font-extrabold font-display text-emerald-400">{h.after_score}</div><div className="text-xs text-muted-foreground">% of lines flagged (lower is better)</div></div>
            <div className="card-surface text-sm"><div className="label-xs mb-1">Code guard</div>Locked and Tier 1/2 keywords, numbers, titles and dates must stay identical. <span className="text-rose-300">{h.rewrites.filter((r) => !r.valid).length}</span> rewrite(s) rejected by code.</div>
          </div>
          <div className="space-y-3" data-testid="humanize-rewrites">
            {h.rewrites.map((rw) => (
              <ChangeCard key={rw.id} ch={rw} onDecide={decide} idp="humanize-rewrite">
                <div className="flex flex-wrap gap-1">{rw.reasons.map((r) => <span key={r} className="text-[11px] px-1.5 py-0.5 rounded bg-amber-500/10 text-amber-300">{r}</span>)}</div>
                {rw.errors.map((e) => <div key={e} className="text-xs text-rose-300 flex gap-1"><ShieldX size={12} /> Rejected: {e}</div>)}
              </ChangeCard>
            ))}
            {!h.flags.length && <div className="card-surface text-sm text-emerald-300">No AI-tell patterns found.</div>}
          </div>
          {h.remaining_flags.length > 0 && (
            <div className="card-surface"><div className="label-xs mb-2">Still flagged after rewrites</div>
              {h.remaining_flags.map((f) => <div key={f.id} className="text-xs text-slate-400 py-0.5"><span className="font-mono text-blue-300">{f.id}</span> {f.reasons.join("; ")}</div>)}</div>
          )}
        </>
      )}
    </StageShell>
  );
}
